"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const IntegrationIcon = (props) => {
    return (react_1.default.createElement("svg", { className: props.size, viewBox: "0 0 24 24", fill: "none" },
        react_1.default.createElement("path", { className: props.color, d: "M4 22V16.9375C4 15.8417 4.88889 15.5517 5.61156 16.2317C5.96622 16.5633 6.26044 17 7.12978 17C8.096 17 9.33333 16.0767 9.33333 14.5C9.33333 12.9233 8.096 12 7.12978 12C6.25956 12 5.96533 12.4367 5.61156 12.7683C4.88889 13.4483 4 13.1592 4 12.0625V7H9.4C10.5689 7 10.8782 6.16667 10.1529 5.48917C9.79911 5.15667 9.33333 4.88083 9.33333 4.06583C9.33333 3.16 10.3182 2 12 2C13.6818 2 14.6667 3.16 14.6667 4.06583C14.6667 4.88083 14.2009 5.15667 13.8471 5.48917C13.1218 6.16667 13.4302 7 14.6 7H20V22H4Z" })));
};
exports.default = IntegrationIcon;
